import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-10" data-id="element-57" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-58" data-mp="3gezf99jl213s">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.22em] text-white" data-id="element-59" data-mp="3ggkal1dq1o2p">
          Negocio Rentable
        </p>
        <p className="mt-3 text-xs leading-relaxed text-white/60" data-id="element-60" data-mp="36p6aardy4k8i">
          Más control. Más ganancia. Más tranquilidad. Los resultados dependen de
          la implementación de cada emprendedor.
        </p>
        <p className="mt-4 text-xs text-white/40" data-id="element-61" data-mp="398xsbsbb070">
          © {new Date().getFullYear()} Negocio Rentable. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}